window.addEventListener("load", function(){
    document.querySelector('.hidden').classList.toggle("hidden2");
    document.querySelector('.loader').classList.toggle("loader2")
});

document.addEventListener('DOMContentLoaded', function () {
    fetch('../partials/footer.html') // Ruta relativa al archivo navbar.html
        .then(response => response.text())
        .then(data => {
            document.getElementById('footer-container').innerHTML = data;
        })
        .catch(error => console.error('Error al cargar el footer:', error));
});




  
    const translations = {
        en: {
            "Inicio": "Home",
            "Inicios": "Home | Carretones Brito",
            "Productos": "Products",
            "Todo_carga": "Fixed Lowboys",
            "Fijo": "Fixed Lowboys",
            "Des": "Detachable Lowboys",
            "Ra": "Folding Lowboys",
            "Todo_cargas": "Fixed",
            "Desmo": "Detachable",
            "ram": "Folding",
            "Modulos": "Modular Trailers",
            "Direccionales": "Steering Trailers",
            "Direccionaless": "Steering",
            "Equipamientos": "Equipment",
            "Novedades": "News",
            "Nosotros": "About Us",
            "Clientes": "Clients",
            "Contáctanos": "Contact Us",
            "Consultas": "Request A Quote",
            "Enviar mensaje": "Send Message",
            "Nombre": "Name",
            "Error_nombre": "Enter your name",
            "Error_email": "Enter your email",
            "Error_telefono": "Enter your phone",
            "Error_lugar": "Enter your location",
            "Error_mensaje": "Enter your message",
            "Email": "Email",
            "Telefono": "Phone",
            "Lugar": "Location",
            "Mensaje": "Message",
            "Visitenos": "Visit Us",
            "Planta Industrial": "Industrial Plant",
            "Nuestra": "Our Mission",
            "Crear": "Make the best Lowboys for Heavy Transport",
            "Empezar": "Start",
            "Suscribirse": "Subscribe",
            "Ingrese": "Enter your email",
            "Ingrese_placeholder": "Enter your email",
            "Suscribirse": "Subscribe",
            "Espec_modulos": "A lot of configurations Modular Trailer payloads ranging from 30 to 150 ton capacities, and axle configurations ranging from 3 to 12 lines.",
            "Espec_todo": "A lot of configurations Lowboys payloads ranging from 30 to 120 ton capacities, and axle configurations ranging from 3 to 12 axles.",
            "Espec_equipamientos": "A lot of configurations dollies axle configurations ranging from 1 to 6 axles and, Beds-Gondolas and accessories for oversized loads.",
            "mas": "See More" ,
            "Vanguardia": "Leading-edge" ,
            "Diseno": "design" ,
            "Texto_Nosotros": "We are the lowboys factory leader in the Argentine market, with over 40 years of experience developing and innovating in lowboys for heavy and oversized loads." ,
            "Politicas": "QUALITY POLICIES",
            "Trabajar": "1 - WORK ON CONTINUOUS IMPROVEMENT.",
            "Destacarse": "2 - STAND OUT FOR FLEXIBILITY AND FUNCTIONABILITY.",
            "Capacitarse": "3 - TRAIN AND ACQUIRE THE REQUIRED SKILLS.",
            "Aportar": "4 - CONTRIBUTE TO THE IMPROVEMENT OF THE WORK ENVIRONMENT.",
            "Alcance": "SCOPE: DESIGN, MANUFACTURING AND AFTER-SALES SERVICE OF LOWBOYS, SEMI-TRAILERS AND HYDRAULIC MODULES FOR HEAVY AND SPECIAL LOAD TRANSPORT.",
            "Descripcion": "Description" ,
            "Modelos": "Models",
            "Usos": "Uses",
             "Carga": "Max Load",
             "Pesos": "Weights and Dimensions",
             "Pesoss": "Vehicles that transport exceptional loads (Lowboys).","Pesost": "Special vehicles with conventional axles",
             "Pesoste": ", configured with conventional axles and a low platform; they may travel with a maximum gross vehicle weight (45 t). They will require a permit to travel loaded for each trip.",
             "Pesostes": "Special vehicles with multiple wheel axles",
             "Pesostese": "(distributed in a manner other than dual-wheel axles) with FOUR (4) to EIGHT (8) wheels per axle: they may circulate with loads exceeding their dimensions.",
             "Cerrar": "Close",
             "Neumaticos": "Wheels",
             "Cuello": "Lowboys",
             "Tipos_Neumaticos": "Tire Types",
             "Neumaticos_carretones": "Lowboys tires",
             "Baja_Neumaticos": "Low Height",
             "Alta_Neumaticos": "High Height",
             "Plataforma": "Flatbed",
             "Suspension": "Suspension",
             "Neumatica": ": Air - Mechanical",
             "Accesorios": "Accessories",
             "Accesorio": ": Swing-out outriggers  -  Extendable Bumper - Hydraulic Ramps",
             "Tecnologia": "Manufacturing Technology",
             "Diseno": "Design",
             "Disenos": "Robust structures are designed for the transport of heavy machinery (concentrated loads).",
             "Materiales": "Materials",
             "Materiale": "We use high-strength steel and profiles.",
             "Terminacion": "Paint",
             "Terminaciones": "Coating processes with a double anti-corrosion base.",
             "Terminacioness": "Surfaces are finished with a double coating, using anti-rust primer and/or primer, and a synthetic or polyurethane-based color is applied at the customer's choice.",
             "Ejes": "SINGLE-AXLES",
             "Eje": "MULTI-AXLES",
             "Pedir": "Request information",
             "Construccion": "Construction",
             "Masi": "More",
             "Energia": "Energy",
             "Cisne": "Gooseneck",
             "Instalaciones": "Air/Electrical",
             "Cisnes": "It is fully outfitted with a full-width top deck for operation, and includes an additional ramp-deck accessory to load rolling equipment onto it. Heavy-duty models feature two kingpin positions to attach 24-wheel dollies.",
             "Plataformas": "It is designed according to its intended use and the cargo to be transported, using high-strength W-profile steel sections to optimize the vehicle’s tare weight.",
             "Suspensions": "It is equipped with Hendrickson-style air suspensions for standard dollies and/or 3.54-inch-wide reinforced elastomer spring hangers, and on heavy-duty dollies it is fitted with all-terrain mechanical rocker suspensions for overloads, as well as air suspensions with lift and/or hydraulic suspensions.",
             "Instalacioness": "We use approved equipment on all trucks with an ABS system and dual-chamber spring brakes on all suspension models. Our units have approved LED lighting and regulatory reflective tape.",
             "Rampas": "Hydraulic Ramps",
             "Mensulas": "Swing-out outriggers ",
             "Patas": "hydraulic stabilizer legs",
             "Ramp": "Platform ramp",
             "Paragolpe": "Extendable Bumper",
             "mas_info": "More information",
             "Plataformase": "Straight - Low - Extendable",
             "Meinte_todo": "I'm interested in Fixed Lowboys",
             "Meinte_desmo": "I'm interested in Detachable Lowboys",
             "Meinte_rampa": "I'm interested in Folding Lowboys",
             "Meinte_modu": "I'm interested in Modular Trailers",
             "Meinte_dire": "I'm interested in Steering Trailers",
             "Meinte_compe": "I'm interested in Equipment",
             "Todd": "Fixed Lowboys | Lowboys",
             "Todde": "Detachable Lowboys | Lowboys",
             "Toddes": "Folding Lowboys | Lowboys",
             "Toddess": "Modular Trailers | Lowboys",
             "Toddid": "Steering Trailers | Lowboys",
             "Todda": "Equipament | Lowboys",
             "Mineria": "Mining",
             "Booster": "One or two-line folding booster.",
             "mensaje enviado": "Message sent successfully",
             "Malacate": "Hydraulic Winches.",
             "Rolo": "Pneumatic Rollers.",
             "Hidraulica": ": Hydrailic",
             "Copiador": ": Articulated Copier Steering",
             "Configuraciones": "CONFIGURATIONS",
             "mod": "Modules",
             "hidras": "Hydraulic",
             "cabeza": "Heads",
             "cabezas": "Modular equipment has a head at each end of the convoy, to steer the unit using a drawbar, following the movement of the tractor. Each head contains a hydraulic control unit, a control console, and a central steering wheel.",
             "modes": "The modules come in 3, 4, 5, and 6 rows, where each row is made up of two axles with four tires each. These units are coupled together to transport different types of loads, and they also have an integrated steering system.",
             "cisnese": "Fully covered, it articulates all the way to the ground, positioning itself as a ramp for all types of machines with a 5° slope, or straight, becoming a platform. The heavy-duty models have two kingpin positions for coupling 24-tire dollies.",
             "Cisneses": "A fully articulated neck is used for different heights. Heavy-duty models have two kingpin positions for attaching 24-tire dollies.",
             "Cisnesese": "A fully articulated neck is used for different heights. It is equipped with a rotating ring with a copying system that allows the tractor's turn to be emulated and repeated in reverse on the running gear. The system can also be detached.",
             "unidad": "It is equipped with hydraulic suspension and has a 24-inch track width.",
             "puede": "A fully articulated gooseneck can be attached for different operating heights. They can be equipped with a copying system to follow the tractor's turn, and a compensation system to hydraulically transfer loads to the tractor. Heavy-duty models have two kingpin positions for attaching 24-wheel dollies.",
             "plata": "Designed based on the use and load to be transported, high-strength W-profiles are used to optimize the vehicle's tare weight. The vehicle can be extended, low, straight, or with split beams.",
             "Neumaticos_ca": "Tires",
             "Baja_Ne": "Height (35 in to 59 in)",
             "Ensanchadores": "Wideners",
             "equisa": ": Dollies - Boosters",
             "equi": "Equipment",
             "equis": "Hydraulic hitch plate.",
             "equise": "Tractor counterweights.",
             "equises": "150-ton drawbar.",
             "Platafor": "Designed based on the use and load to be transported, high-strength W-profiles are used to optimize the vehicle's tare weight. Three-gauge rails can be installed for rail transport, and can also be extended for long loads.",
             "Suspensioni": "It is equipped with Hendrickson-type pneumatic suspensions for conventional trucks, and hydraulic suspensions are installed on heavy-duty trucks.",
             "Plataformases": "Straight",
             "Compensa": "Equipament",
             "Dolli": "Dollies",
             "Nue": "Our dolly model is designed to be used as a dolly or as a booster. The neck detaches for use as a booster or as a running gear on a wagon.",
             "Plataforme": "The platform can be equipped with a rotating ring and a hydraulic system for use as a booster.",
             "Giratorio": "Rotating ring.",
             "Sistema": "Hydraulic system.",
             "Comando": "Remote control.",
             
             



            
            
          

        }
  
    };


        
            
           



    
    document.addEventListener('DOMContentLoaded', function () {
        // Cargar el navbar
        fetch('../partials/navbar.html') // Ruta relativa al archivo navbar.html
            .then(response => response.text())
            .then(data => {
                document.getElementById('navbar-container').innerHTML = data;
    
                // Detectar la página activa y agregar la clase 'item-active'
                const items = document.querySelectorAll('.barra .item');
                const currentPath = window.location.pathname;
    
                items.forEach(item => {
                    const link = item.getAttribute('href');
                    // Normalizar las rutas para evitar problemas con rutas relativas
                    const normalizedLink = new URL(link, window.location.origin).pathname;
                    if (currentPath === normalizedLink) {
                        item.classList.add('item-active');
                    }
                });
    
                // Ahora que el navbar está cargado, inicializamos el selector de idioma
                const languageSelect = document.getElementById('languageSelect');
                const elements = document.querySelectorAll('[data-translate]');
    
                // Recuperar el idioma seleccionado del localStorage
                const savedLanguage = localStorage.getItem('selectedLanguage') || 'es'; // Por defecto 'es'
                languageSelect.value = savedLanguage;
                function translatePage(language) {
                    const elements = document.querySelectorAll('[data-translate]');
                    elements.forEach(el => {
                        const key = el.getAttribute('data-translate'); // Obtiene la clave de traducción
                        if (translations[language] && translations[language][key]) {
                            if (el.hasAttribute('placeholder')) {
                                el.setAttribute('placeholder', translations[language][key]); // Traduce el placeholder
                            } else if (el.tagName === 'TEXTAREA') {
                                el.value = translations[language][key]; // Traduce el valor del textarea
                            } else {
                                el.textContent = translations[language][key]; // Traduce el texto
                            }
                        } else {
                            console.warn(`No translation found for key: ${key}`);
                        }
                    });
                }

function translatePage(language) {
    const elements = document.querySelectorAll('[data-translate]');
    elements.forEach(el => {
        const key = el.getAttribute('data-translate'); // Obtiene la clave de traducción
        if (translations[language] && translations[language][key]) {
            if (el.hasAttribute('placeholder')) {
                el.setAttribute('placeholder', translations[language][key]); // Traduce el placeholder
            } else if (el.tagName === 'TEXTAREA') {
                el.value = translations[language][key]; // Traduce el valor del textarea
            } else {
                el.textContent = translations[language][key]; // Traduce el texto
            }
        }
        // Si no existe key, no hace nada y no muestra error
    });
}


                      
    
                // Traducir la página al cargar
                translatePage(savedLanguage);
    
                // Cambiar idioma al seleccionar una opción
                languageSelect.addEventListener('change', function () {
                    const selectedLanguage = this.value;
                    localStorage.setItem('selectedLanguage', selectedLanguage); // Guardar el idioma seleccionado
    
                    if (selectedLanguage === 'es') {
                        location.reload(); // Recargar la página si se selecciona español
                    } else {
                        translatePage(selectedLanguage); // Traducir dinámicamente para otros idiomas
                    }
                });
            })
            .catch(error => console.error('Error al cargar el navbar:', error));
    });
   
    document.addEventListener("DOMContentLoaded", function () {
        // Detectar el idioma del navegador
        const userLang = navigator.language || navigator.userLanguage;
    
        // Seleccionar el elemento del selector de idioma
        const languageSelect = document.getElementById("languageSelect");
    
        // Si el idioma del navegador es inglés, selecciona "ES" por defecto
        if (userLang.startsWith("en")) {
            languageSelect.value = "es";
            //console.log("Idioma detectado: Inglés. Se ha seleccionado 'ES' por defecto.");
        } else {
            //console.log(`Idioma detectado: ${userLang}. No se realizaron cambios en el selector.`);
        }
    });

  


    